































































































import { Vue, Component, Ref, Prop, Watch } from 'vue-property-decorator'
import * as Y from 'yjs'
import Delta from 'quill-delta'
import arrayCrdtSortNumber from 'src/assets/arrayCrdtSortNumber'
import { svgIcon } from 'src/assets/icons'
import FileFolder from 'components/presenter/item/FileFolder.vue'
import ExpandablePreview from 'components/ExpandablePreview.vue'
import SlickList from 'components/SlickList.vue'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import FileListItem from 'components/presenter/item/topic/editor/InfoEditorFileListItem.vue'
import FileForm from 'components/presenter/item/topic/editor/InfoEditorFileForm.vue'
import ImageForm from 'components/presenter/item/topic/editor/InfoEditorImageForm.vue'
import MarkdownEditorCrdt from 'components/MarkdownEditorCrdt.vue'
import MarkdownViewerCrdt from 'components/MarkdownViewerCrdt.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    FileFolder,
    ExpandablePreview,
    SlickList,
    DialogFullscreen,
    FileListItem,
    FileForm,
    ImageForm,
    MarkdownEditorCrdt,
    MarkdownViewerCrdt
  }
})
export default class ItemInfoEditor extends Vue {
  loading: number = 0
  reorder = false
  files: Json[] = []
  file: Json = {}

  @Prop()
  readonly item!: Item

  @Prop()
  readonly title!: string

  @Ref()
  readonly dialog!: FileForm

  @Ref()
  readonly infoEditor!: DialogFullscreen

  @Ref()
  readonly imageEditor!: DialogFullscreen

  @Ref()
  readonly editor!: MarkdownEditorCrdt

  @Ref()
  readonly folder!: FileFolder

  get info (): Y.Doc {
    return this.item.data?.info?.text || new Y.Doc()
  }

  get coverImageId (): number {
    return this.item.data?.info?.coverImageId || 0
  }

  get toolbar () {
    return [{
      hotkey: '⇧⌘A',
      name: 'file',
      tipPosition: 'n',
      tip: 'Insert File',
      className: 'right',
      icon: svgIcon('attach-outline'),
      click: () => {
        this.folder.show()
      }
    }]
  }

  @Watch('item.data', { immediate: true, deep: true })
  setFiles(data: Json) {
    this.files = (Object.values(data?.info?.files || {}) as Json[]).filter(x => x.id && x.id !== data?.info?.coverImageId && !x.deleted).sort((a, b) => a.sort - b.sort)
  }

  attach () {
    this.file = {
      id: null,
      url: '',
      name: '',
      hide: false
    }
    this.dialog.show()
  }

  async moveFile({ newIndex, oldIndex }: { newIndex: number, oldIndex: number }) {
    const file = this.files[oldIndex]
    const infoSettings: Json = {}
    infoSettings[`files:${file.id}:sort`] = arrayCrdtSortNumber(this.files, newIndex, oldIndex)
    await this.item.data?.save({ infoSettings })
  }

  updateInfo (delta: Delta) {
    if (!this.item.data?.info?.text) {
      this.item.data?.update({
        infoTexts: { text: [] }
      })
    }
    this.info.transact(() => {
      this.info.getText().applyDelta(delta.ops)
    }, 'INFO_EDIT')
  }

  fileSelect (file: Json) {
    this.folder.hide()
    const fileName = file.src.replace(/(\/\d+)+\/.{36}\./g, '')
    if (file.type.startsWith('image')) {
      this.editor.content.insertValue(`![${fileName}](${file.src})`)
    } else {
      this.editor.content.insertValue(`[${fileName}](${file.src})`)
    }
  }
}
